import { FormSearchStyled } from "./style";
import { useContext } from "react";
import { UserContext } from "../../../../../providers/UserContext";
import { SubmitHandler, useForm } from "react-hook-form";
import { iFormSearchValues } from "./types";
import { ButtonStyled } from "../../../../../style/button";
import Searching from "../../../../../assets/img/Searching.svg";

export const FormSearchProducts = () => {
  const {
    setFilterProducts,
    products,
    filterProducts,
    setShowInputSearch,
    showInputSearch,
  } = useContext(UserContext);

  const { register, handleSubmit } = useForm<iFormSearchValues>({
    mode: "onChange",
  });

  const handlerOnChange = (e: string) => {
    submit({ name: e });
  };

  const submit: SubmitHandler<iFormSearchValues> = (data) => {
    console.log(data);
    const filter = products.filter((product) =>
      filterProducts.length === 0
        ? products
        : product.name.toLowerCase() === data.name.toLowerCase()
    );
    setFilterProducts(filter);
  };

  return (
    <FormSearchStyled onSubmit={handleSubmit(submit)}>
      <input
        type="text"
        id="name"
        placeholder="Digite sua pesquisa"
        {...register("name")}
        onChange={(e) => handlerOnChange(e.target.value)}
      />
      <ButtonStyled
        type="submit"
        buttonStyle="default"
        onClick={() => {
          showInputSearch
            ? setShowInputSearch(false)
            : setShowInputSearch(true);
        }}
      >
        <img src={Searching} alt="" />
      </ButtonStyled>
    </FormSearchStyled>
  );
};
